import React, { FC } from 'react'
import { Button } from 'antd'
import { ButtonProps } from 'antd/lib/button'
import styled from '@emotion/styled'

const DDButton: FC<ButtonProps> = ({ children, ...props }) => {
  return <StyledDDButton {...props}>{children}</StyledDDButton>
}

const StyledDDButton = styled(Button)`
  background: transparent;
  height: 28px;
  min-width: 94px;
  border-color: transparent;
  padding: 0 16px;
  font-size: 14px;
  color: #3e3e3e;
  border-radius: 4px;
  &:focus,
  &:hover {
    border-color: #000;
    color: #000;
  }
  &.ant-btn:not([disabled]):hover {
    background: transparent;
  }
  &.ant-btn-primary {
    background: var(--main-button-bg-color);
    border-color: transparent;
    color: var(--main-button-text-color);
    box-shadow: none;
    &:not([disabled]):hover,
    &:focus,
    &:hover {
      background: var(--main-button-bg-color);
      filter: brightness(1.1);
      border-color: transparent;
      color: var(--main-button-text-color);
      filter: brightness(0.9);
    }
    &.gradient {
      background-image: linear-gradient(
        90deg,
        var(--main-btn-gradient-light-color) 0%,
        var(--main-btn-gradient-dark-color) 100%
      );
      &:not([disabled]):hover,
      &:focus,
      &:hover {
        filter: brightness(1);
        background: linear-gradient(
          90deg,
          var(--main-btn-gradient-dark-color) 0%,
          var(--main-btn-gradient-light-color) 100%
        );
        /* background-size: 200%;
        background-position: 0 0; */
        border-color: transparent;
        color: var(--text-color-1);
      }
    }
  }
  &.ant-btn-round {
    border-radius: 32px;
  }
  &.disable {
    background: var(--btn-disabled-bg) !important;
    border-color: var(--btn-disabled-border) !important;
    color: var(--btn-disabled-color) !important;
    opacity: 0.5;
  }
`
export default DDButton
